module.exports = __webpack_public_path__ + "img/vistec_logo.71c2a2d6.png";